module.exports = __webpack_public_path__ + "31322ec7d035c9bcfc00fe1bc54d4d3f.MP3";